function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_180",
  "data-name": "Path 180",
  d: "M305.3,215.957c.191-.006.337,1.867.37,2.362a31.838,31.838,0,0,1-2.144,13.549c5.362,2.182,11.933,2.5,17.743,2.071,1.716-.125,3.483-.31,5.3-.514a88.294,88.294,0,0,1,17.373-.363v-.006c-3.205-6.55-3.693-11.682-1.9-18.74-7.782,1.2-17.862,3.779-25.751,3.061a26.4,26.4,0,0,1-10.917-3.423c-.942-.608-.864-.719.172-.357a34.218,34.218,0,0,0,10.843,2.349,53.385,53.385,0,0,0,11.55-1.122,92.439,92.439,0,0,1,15.1-1.418,61.3,61.3,0,0,0,1.992,20.4v.006c-7.882.461-15.845,1.846-23.621,2.288-7.236.415-12.487-.185-19-3.753a71.761,71.761,0,0,0,2.605-14.031,10.6,10.6,0,0,1,.3-2.354Z",
  transform: "translate(-283.158 -184.646)",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_255",
  "data-name": "Rectangle 255",
  width: 43.903,
  height: 24.009,
  transform: "translate(18.073 27.914)",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M338.5,218.959c-.033-.013-.053-.092-.039-.224a2.486,2.486,0,0,1,.144-.555,4.337,4.337,0,0,1,.415-.843,5.468,5.468,0,0,1,.8-1.023,8.794,8.794,0,0,1,1.972-1.425c.4-.217.824-.428,1.266-.633s.911-.415,1.365-.633a19.5,19.5,0,0,0,2.2-1.259,17.9,17.9,0,0,0,2.2-1.722,14.714,14.714,0,0,0,1.979-2.235,11.567,11.567,0,0,0,1.47-2.777,10.28,10.28,0,0,0,.521-5.415,8.479,8.479,0,0,0-2.492-4.638,7.094,7.094,0,0,0-.977-.771,10.082,10.082,0,0,0-3.733-1.464,15.9,15.9,0,0,0-5.508.086c-1.042.184-2.058.428-3.047.705s-1.959.586-2.909.89-1.873.594-2.777.864-1.787.5-2.644.693a29.865,29.865,0,0,1-4.842.693,25.771,25.771,0,0,1-3.7-.033,15.637,15.637,0,0,1-2.315-.329c-.528-.125-.8-.238-.785-.331s.29-.138.818-.185,1.306-.072,2.288-.138,2.177-.179,3.542-.389a35.619,35.619,0,0,0,4.552-1c.8-.231,1.635-.508,2.5-.811s1.767-.641,2.71-.976,1.92-.686,2.956-1.009a30.624,30.624,0,0,1,3.245-.845,17.47,17.47,0,0,1,6.326-.185,11.925,11.925,0,0,1,4.63,1.807,11.442,11.442,0,0,1,1.266,1,10.618,10.618,0,0,1,3.154,5.969,11.837,11.837,0,0,1,.06,3.437,12.671,12.671,0,0,1-.838,3.16,13.64,13.64,0,0,1-1.853,3.193,15.721,15.721,0,0,1-2.349,2.453,17.7,17.7,0,0,1-2.546,1.774,18.383,18.383,0,0,1-2.494,1.188c-.508.2-1,.369-1.444.527s-.878.31-1.26.462a8.313,8.313,0,0,0-1.887,1.016,6.234,6.234,0,0,0-.851.746c-.23.237-.409.461-.553.64-.3.369-.456.58-.534.547",
  transform: "translate(-279.253 -190.655)",
  fill: "#707070"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_256",
  "data-name": "Rectangle 256",
  width: 39.34,
  height: 29.603,
  transform: "translate(36.649)",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_183",
  "data-name": "Path 183",
  d: "M299.348,201.22c.032.079-1.815.695-2.092.912s-.713.514-1.246.89-1.182.851-1.893,1.425a26.034,26.034,0,0,0-2.29,2.091,19.286,19.286,0,0,0-2.11,2.586,11,11,0,0,0-1.538,3.278,8.347,8.347,0,0,0-.263,3.265,6.485,6.485,0,0,0,1.121,2.929,20.584,20.584,0,0,0,1.947,2.019,7.073,7.073,0,0,0,3.687,1.331,9.392,9.392,0,0,0,2.948-.033,13.613,13.613,0,0,0,2.765-.771,15.4,15.4,0,0,0,4.293-2.586,17.524,17.524,0,0,0,2.73-2.889c.672-.89,1.141-1.655,1.47-2.177a12.533,12.533,0,0,1,1.346-1.921c.111.039.111.4-.041,1.022a10.775,10.775,0,0,1-1.028,2.6,15,15,0,0,1-2.6,3.489,16,16,0,0,1-4.65,3.24,14.01,14.01,0,0,1-3.2,1.035,11.807,11.807,0,0,1-3.655.125,9.343,9.343,0,0,1-4.9-2.149,8.148,8.148,0,0,1-2.8-5.469,10.143,10.143,0,0,1,.455-4.155,13.088,13.088,0,0,1,2.012-3.8,16.684,16.684,0,0,1,2.546-2.691,20.562,20.562,0,0,1,2.679-1.953,16.99,16.99,0,0,1,2.216-1.141,8.645,8.645,0,0,1,1.5-.5c.357-.079.561-.079.6,0",
  transform: "translate(-287.184 -187.904)",
  fill: "#707070"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_258",
  "data-name": "Rectangle 258",
  width: 23.139,
  height: 23.641,
  transform: "translate(0 12.717)",
  fill: "none"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M332.793,194.3c-.039.191-1.708-.9-3.357-1.009s-4-.276-6.834-.369c-1.84-.059-3.892-.086-6.049.053a31.834,31.834,0,0,0-6.688,1.082c-.271.079-.542.158-.805.243a22.3,22.3,0,0,0-3.462,1.451,19.658,19.658,0,0,0-2.956,1.881,16.35,16.35,0,0,0-2.321,2.169,14.223,14.223,0,0,0-1.655,2.3,14.965,14.965,0,0,0-1.266,2.757,19.217,19.217,0,0,0-.614,2.256c-.138.64-.217,1.147-.3,1.5s.567,1.63.483,1.636-.185-.179-.277-.541a7.764,7.764,0,0,1-.172-1.6,12.557,12.557,0,0,1,.238-2.527,13.974,13.974,0,0,1,1.061-3.218,14.639,14.639,0,0,1,1.689-2.738,17.333,17.333,0,0,1,2.48-2.605,19.96,19.96,0,0,1,3.232-2.229,21.646,21.646,0,0,1,3.839-1.643c.291-.092.588-.185.884-.265a30.082,30.082,0,0,1,7.223-1.061,45.031,45.031,0,0,1,6.293.27,47.189,47.189,0,0,1,6.867,1.208c1.622.422,2.506.8,2.467,1",
  transform: "translate(-284.727 -190.396)",
  fill: "#707070"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_184",
  "data-name": "Path 184",
  d: "M330.717,214.84c-.138-.006-.257-.191-.35-.528a6.2,6.2,0,0,1-.165-1.437,15.48,15.48,0,0,1,.792-4.854,18.444,18.444,0,0,1,2.955-5.561,15.368,15.368,0,0,1,2.064-2.2,8.428,8.428,0,0,1,1.663-1.161c.442-.218.738-.271.843-.146s.014.4-.217.812-.608.95-1.056,1.61-.983,1.437-1.53,2.321-1.1,1.873-1.63,2.942c-.362.732-.685,1.458-.969,2.157-.68,1.676-1.141,3.193-1.5,4.288a11.2,11.2,0,0,1-.481,1.292c-.144.3-.284.469-.415.462",
  transform: "translate(-275.752 -188.51)",
  fill: "#707070"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_185",
  "data-name": "Path 185",
  d: "M324.976,215.856c-.132.027-.3-.119-.475-.415a5.8,5.8,0,0,1-.547-1.346,13.755,13.755,0,0,1-.409-2.15,16.343,16.343,0,0,1-.059-2.763,19.028,19.028,0,0,1,.323-2.408,17.774,17.774,0,0,1,1.1-3.476,14.38,14.38,0,0,1,1.445-2.585,8.161,8.161,0,0,1,1.318-1.511c.37-.3.64-.422.773-.329s.111.382-.008.831-.35,1.049-.619,1.787-.581,1.6-.884,2.572-.588,2.045-.824,3.18c-.152.745-.271,1.47-.363,2.163-.237,1.781-.3,3.364-.362,4.519a10.407,10.407,0,0,1-.125,1.379c-.06.329-.152.527-.284.553",
  transform: "translate(-277.55 -188.522)",
  fill: "#707070"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_186",
  "data-name": "Path 186",
  d: "M309.269,214.758c-.263-.06-.409-.528-.528-1.24s-.2-1.669-.376-2.744c-.066-.415-.144-.851-.237-1.293-.284-1.372-.653-2.592-.911-3.528a6.742,6.742,0,0,1-.257-1.168c-.033-.3,0-.514.138-.607s.351-.06.627.111a4.118,4.118,0,0,1,.956.878,8.179,8.179,0,0,1,1.009,1.616,10.439,10.439,0,0,1,.74,2.216,9.482,9.482,0,0,1,.191,1.556,7.855,7.855,0,0,1-.448,3.133,2.878,2.878,0,0,1-.462.832c-.158.184-.31.263-.442.237",
  transform: "translate(-281.948 -187.114)",
  fill: "#707070"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M316.793,215.449c-.132-.033-.211-.23-.263-.567s-.066-.8-.086-1.372a35.2,35.2,0,0,0-.343-4.492,22.523,22.523,0,0,0-.455-2.288,25.03,25.03,0,0,0-1.023-3.16c-.375-.956-.771-1.807-1.115-2.52s-.646-1.3-.824-1.735-.231-.726-.111-.831.409-.027.817.251a7.963,7.963,0,0,1,1.5,1.392,13.978,13.978,0,0,1,1.7,2.527,15.922,15.922,0,0,1,1.76,6.114,14.831,14.831,0,0,1-.046,2.79,11.992,11.992,0,0,1-.448,2.157,5.813,5.813,0,0,1-.575,1.34c-.191.29-.356.428-.488.4",
  transform: "translate(-280.467 -188.63)",
  fill: "#707070"
});

function SvgCook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_139_1",
    "data-name": "Component 139 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.989,
    height: 51.924,
    viewBox: "0 0 75.989 51.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCook);
export default __webpack_public_path__ + "static/media/cook.b3df469c52c5dfcfeb34086c6111ac1d.svg";
export { ForwardRef as ReactComponent };